﻿import api from '../api';
import { Pergunta } from './Pergunta';

export interface Resposta {
  editavel: boolean;
  id: string;
  descricao: string;
  perguntaId: string;
  ordem: string | number;
  isChecked: boolean;
}

export interface RespostasList {
  respostas?: Resposta[];
}

export const UpdateResposta = (values: any) => api.put('cadastroRespostas/putResposta', values);
export const getAllResposta = () => api.get<Resposta[]>('cadastroPerguntas/getPergunta');
export const putAtualizarDescricaoResposta = (values: Resposta) =>
  api.put('cadastroRespostas/putAtualizarDescricaoResposta', values);
export const getAllRespostaByPerguntaId = (perguntaId: string) =>
  api.get<Resposta[]>(`cadastroRespostas/getAllRespostaByPerguntaId/${perguntaId}`);
export const getAllRespostaByPerguntaIdOptions = (perguntaId: string) =>
  getAllRespostaByPerguntaId(perguntaId)
    .then(data => (data || []).map(a => ({ text: a.descricao, value: a.id.toString() })));
export const UpdateManyResposta = (values: RespostasList) => {
  return api.put(`cadastroRespostas/updateManyResposta`, values);
};
